import { useEffect, useState } from "react";

type Props = {
  notification: string;
  duration?: number; // how long it stays visible (ms)
};

export function NotificationToast({ notification: eventType, duration = 20_000 }: Props) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!eventType || eventType === "(no events yet)") return;
    setVisible(true);

    // Automatically hide after timeout
    const timer = setTimeout(() => setVisible(false), duration);

    // Hide on click anywhere in the document
    const handleClick = () => setVisible(false);
    document.addEventListener("click", handleClick);

    // Cleanup on unmount or when eventType changes
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleClick);
    };
  }, [eventType, duration]);

  if (!visible) return null;

  //bg-indigo-950 text-white
  return (
    <div
      className={`fixed bottom-6 mt-2 left-1/2 -translate-x-1/2 px-6 py-6 px-4 rounded-lg shadow-lg
         text-3xl font-medium transition-opacity duration-[1500ms] notification
        ${visible ? "opacity-70" : "opacity-0 pointer-events-none"}`}
    >
      {eventType}
    </div>
  );
}
